import { Fragment } from 'react';
import NsContent from 'components/common/ns-content/NsContent';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrice } from 'components/common/ns-price/NsPrice';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { useCtaCardFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';

export const testId = 'chooseTariffCardTestId';

type ChoooseTariffCardProps = {
  shouldShow?: boolean;
  handleGoNext?(event: React.MouseEvent | React.KeyboardEvent): void;
  secondaryCta?: React.ElementType;
  product: {
    monthlyAmount?: number;
    annualAmount?: number;
  };
};

export const ChoooseTariffCard = ({
  product,
  handleGoNext,
  secondaryCta: SecondaryCta = () => null,
  shouldShow = true
}: ChoooseTariffCardProps) => {
  const { monthlyAmount = 0, annualAmount = 0 } = product;
  const ctaCardFeatures = useCtaCardFeatures(product);

  if (!shouldShow) return null;

  return (
    <div>
      <NsCard
        testId={testId}
        type="support"
        action={
          <>
            <p>
              <NsPrimaryCta onClick={handleGoNext}>
                Choose this tariff
              </NsPrimaryCta>
            </p>
            <SecondaryCta />
          </>
        }
      >
        <NsContent>
          <p>Estimated costs (inc. VAT)</p>
          <p>
            <span className="h2">
              <NsPrice amount={monthlyAmount} />
            </span>{' '}
            / month
            <br />
            <NsPrice amount={annualAmount} /> / year
          </p>
          {!!ctaCardFeatures?.length && (
            <p>
              {ctaCardFeatures.map((feature, index) => (
                <Fragment key={index}>
                  {feature.description}
                  <br />
                </Fragment>
              ))}
            </p>
          )}
        </NsContent>
      </NsCard>
    </div>
  );
};
